import React, { useEffect } from "react";
import { GetCurrentStoreData, WebsitesState } from "../../store/websites/types";
import { connect } from "react-redux";
import { getCurrentStoreData } from "../../store/websites/thunks";
import { getPathArray } from "../../helpers/getPathArray";
import { RouteComponentProps, withRouter } from "react-router-dom";
import _ from "lodash";
import { deleteAllPageDynamicData } from "../../store/websitePages/actions";

interface Props extends RouteComponentProps {
  history: any;
  websites: WebsitesState;
  getCurrentStoreData: GetCurrentStoreData;
  deleteAllPageDynamicData: any;
}
const CmsIframe = (props: Props) => {
  const { currentWebsite } = props.getCurrentStoreData();
  if (!currentWebsite) return null;
  const currentAppSection = getPathArray(props.history.location.pathname)[1];
  useEffect(() => {
    if (currentAppSection === "cms") {
      props.deleteAllPageDynamicData()
    }
  }, [currentAppSection])
  return (
    <div
      style={{
        padding: "8px 8px 8px 0",
        minHeight: "100vh",
        lineHeight: 0,
        display: currentAppSection === "cms" ? "block" : "none",
      }}
    >
      <iframe
        style={{
          width: "100%",
          height: "calc(100vh - 16px)",
          boxShadow:
            "rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.1) 0px 1px 2px -1px",
          border: "1px solid rgb(228, 228, 231)",
          borderRadius: "12px",
        }}
        src={`${window.location.origin}/mars/${currentWebsite.id}/collections/`}
        // src={`https://ui.shadcn.com/`}
      ></iframe>
    </div>
  );
};

const mapStateToProps = (state: any) => {
  return {
    websites: state.websites,
  };
};
export default connect(mapStateToProps, {
  getCurrentStoreData,
  deleteAllPageDynamicData,
})(withRouter(CmsIframe));
